import { FormuleConfig } from "../../formule-config/model/FormuleConfig";

export class RuleConfig {
    id: number;
    name: string;
    formule_config_id: FormuleConfig | Number;
    table_origin: string;
    column_origin: string;
    table_destination: string;
    column_destination: string;
    created_at: string;
    updated_at: string;
    user_created: string;
    user_updated_at: string;
    active: boolean = false;
    isOff: boolean = false;
    origin_relationship: string;
    destination_relationship: string;
}